// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3DYDH","header":"PatientQuestionnaire_header__3L642","info":"PatientQuestionnaire_info__21drK"};